// extracted by mini-css-extract-plugin
export default {"buttons":"AMsv9evY","center":"D9GyGcNt","right":"kf4DAXTO"};